export default __webpack_public_path__ + "static/media/maingirl.ade8d4dc.svg";